import { render, staticRenderFns } from "./BusCommonMessageBlackIpModal.vue?vue&type=template&id=36072a0f&"
import script from "./BusCommonMessageBlackIpModal.vue?vue&type=script&lang=js&"
export * from "./BusCommonMessageBlackIpModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports